export default {"src":"/_next/static/media/shopping_center_overview_1.1538d738.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};